import React, { Component } from 'react';
import { Search } from 'lucide-react';
import { GeckoAlert, GeckoFields, ProfileList, Spinner, GeckoBtn} from '../../../../../../components';
import { APP_CONST } from '../../../../../../constants';

export default class ActionBar extends Component {
    state = {
        selected: [],
        search: '',
    }

    onChange(e) {
        this.setState({
            search: e.target.value
        }, () => {
            this.props.onSearch(this.state.search);
        });
    }

    renderSearch() {
        return (
            <div className="ActionBar-search-container flex-1">
                <div className="relative w-full flex items-center">
                    <input
                        type="text"
                        value={this.state.search}
                        placeholder="Filter..."
                        onChange={this.onChange.bind(this)}
                        className="file:text-foreground placeholder:text-slate-500 selection:bg-primary selection:text-primary-foreground border-input flex w-full min-w-0 rounded-sm border bg-transparent px-3 py-1 text-base transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-slate-50 disabled:text-foreground md:text-sm focus-visible:border-slate-500 focus-visible:ring-slate-400/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive pl-9 h-9"
                    />
                    <div className="absolute left-3 pointer-events-none">
                        <Search className="size-4 text-muted-foreground" />
                    </div>
                </div>
            </div>
        )
    }

    renderButtons(buttons) {

        const buttonElements = buttons.map((button, key) => {
            return (
                <GeckoBtn
                    key={key}
                    icon={button.icon}
                    type={APP_CONST.BTN_TYPE_OUTLINE}
                    handler={button.handler}
                    ariaLabel={button.title || button.ariaLabel}
                />
            );
        });

        return (
            <div className="ActionBar-buttons">
                {buttonElements}
            </div>
        )
    }
   
    render () {
        return (
            <div className="ActionBar flex flex-row gap-2">
                {this.renderSearch(this.props.scopes)}
                {this.renderButtons(this.props.buttons)}
            </div>
        );
    }
}